import { render, staticRenderFns } from "./PlotMakerPage.vue?vue&type=template&id=6312ec0b&scoped=true"
import script from "./PlotMakerPage.vue?vue&type=script&lang=ts"
export * from "./PlotMakerPage.vue?vue&type=script&lang=ts"
import style0 from "./PlotMakerPage.vue?vue&type=style&index=0&id=6312ec0b&lang=scss"
import style1 from "./PlotMakerPage.vue?vue&type=style&index=1&id=6312ec0b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312ec0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6312ec0b')) {
      api.createRecord('6312ec0b', component.options)
    } else {
      api.reload('6312ec0b', component.options)
    }
    module.hot.accept("./PlotMakerPage.vue?vue&type=template&id=6312ec0b&scoped=true", function () {
      api.rerender('6312ec0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/PlotMakerPage.vue"
export default component.exports